import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20golden%20hour%20product%20photography%20flat%20lay%20with%20diverse%20fashion%20accessories%20including%20watch%20sunglasses%20leather%20wallet%20and%20silk%20scarf%20on%20textured%20linen%20surface%20rich%20autumn%20tones%20soft%20natural%20sunlight%20elegant%20lifestyle%20composition&width=1600&height=900&seq=cta-section-bg-v2&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 w-full max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-bold text-white tracking-wide">
          {t('cta_section.title', 'START SOURCING SMARTER')}
        </h2>
        <p className="mt-4 text-white/80 text-base md:text-lg leading-relaxed">
          {t('cta_section.subtitle_line1', 'Join thousands of sellers using Itaobuy Sheet')}
          <br />
          {t('cta_section.subtitle_line2', 'to scale their business profitably.')}
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center mt-8 px-8 py-4 rounded-full bg-foreground-950 text-background-50 font-semibold text-sm tracking-wide hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer relative"
        >
          <span className="absolute left-0 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-accent-500 flex items-center justify-center -ml-1">
            <i className="ri-shopping-bag-line text-white text-lg"></i>
          </span>
          <span className="pl-10 pr-2">{t('cta_section.button', 'GET ITAOBUY SHEET NOW')}</span>
          <i className="ri-arrow-right-up-line text-lg"></i>
        </a>
      </div>
    </section>
  );
}